import React from 'react';
import { useSelector } from 'react-redux';
import _ from 'lodash';
import Icon from './Icon';
import Title from './Title';
import Summary from './Summary';

export default function Collapsed() {
  const deliveryDate = useSelector(state => state.checkout.deliveryDate || {});
  const slot = useSelector(state => state.checkout.deliveryTime || {});

  return _.isEmpty(slot) ? (
    <>
      <Icon />
      <Title />
    </>
  ) : (
    <Summary slot={slot} deliveryDate={deliveryDate} />
  );
}
